// @ts-nocheck
/**
 * Heatmap Mock Data - Activity patterns
 */

import { generateHeatmapData } from './helpers';

// Business hours heatmap (24 hours × 7 days)
const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const hours = Array.from({ length: 24 }, (_, i) => i);

export const mockTimeHeatmapData = hours.flatMap((hour) =>
  daysOfWeek.map((day, dayIdx) => {
    // Simulate business hours pattern
    const isWeekday = dayIdx >= 1 && dayIdx <= 5;
    const isBusinessHour = hour >= 9 && hour <= 17;
    const isLunchHour = hour >= 12 && hour <= 13;

    let value = 0;
    if (isWeekday && isBusinessHour) {
      value = isLunchHour
        ? Math.floor(30 + Math.random() * 20)
        : Math.floor(60 + Math.random() * 40);
    } else if (isWeekday) {
      value = Math.floor(Math.random() * 30);
    } else {
      value = Math.floor(Math.random() * 15);
    }

    return {
      x: hour,
      y: day,
      value,
      label: `${day} ${hour}:00`,
    };
  })
);

// Calendar heatmap data (365 days)
export const mockCalendarHeatmapData = (() => {
  const data = [];
  const now = new Date();
  const startDate = new Date(now);
  startDate.setDate(startDate.getDate() - 365);

  for (let i = 0; i < 365; i++) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + i);

    const dayOfWeek = date.getDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    // Simulate activity with weekday/weekend patterns
    let count = isWeekend
      ? Math.floor(Math.random() * 5)
      : Math.floor(5 + Math.random() * 20);

    // Add some seasonal variation
    const month = date.getMonth();
    if (month === 11 || month === 0) {
      // December/January - holiday season
      count = Math.floor(count * 0.6);
    }

    data.push({
      date: date.toISOString().split('T')[0],
      count,
    });
  }

  return data;
})();

// User activity heatmap by region and time
const regions = ['North America', 'Europe', 'Asia', 'South America', 'Africa', 'Oceania'];
const timeSlots = ['00-04', '04-08', '08-12', '12-16', '16-20', '20-24'];

export const mockRegionActivityHeatmap = regions.flatMap((region, regionIdx) =>
  timeSlots.map((slot, slotIdx) => {
    // Simulate timezone-appropriate activity
    const regionalPeak = (slotIdx + regionIdx * 2) % 6;
    const isPeak = Math.abs(slotIdx - regionalPeak) <= 1;

    const value = isPeak
      ? Math.floor(60 + Math.random() * 40)
      : Math.floor(10 + Math.random() * 30);

    return {
      x: slot,
      y: region,
      value,
    };
  })
);
